import React, { useState, useEffect, } from 'react'
import { Link } from 'react-router-dom';
import { Table, Button, Space, Alert, message, Typography, Row, Form, Input, Pagination } from 'antd';
import { DeleteOutlined, EditOutlined, WarningFilled} from '@ant-design/icons';
import { Modal } from '../../UI/Modal/Modal.component';

const { Text, Paragraph } = Typography;

export const VisitTable = ({data, search, setPagination, pagination, ...props}) => {
    console.log(data);

    const [dataSource, setDataSource] = useState(data.logs);
    const [totalRecords, setTotalRecords] = useState(data.count[0].count | 0);
    const [filteredResults, setFilteredResults] = useState('');
    const [currentRow, setCurrentRow] = useState('');
    const [displayModal, setDisplayModal] = useState(false);  

    useEffect(() => {
        console.log(data);
        setDataSource(data.logs);
        setTotalRecords(data.count[0]?.count | 0)
    }, [data])


    const onShowSizeChange = (current, pageSize) => {
        const change = {
            current: current, 
            pageSize: pageSize,
        };        
        setPagination(change);
    };

    const onChange = (page, pageSize) => {
        const change = {
            current: page, 
            pageSize: pageSize,
        };
        window.scrollTo(0,0);
        setPagination(change);
    };

    const columns = [
        {
            title: 'Código',
            dataIndex: 'codigo',
            width: 50,
        },
        {
            title: 'Cliente',
            dataIndex: 'cliente',
            width: 100,
        },
        {
            title: 'Fecha',
            dataIndex: 'fecha',
            width: 50,
        },
        {
            title: 'Planta',
            dataIndex: 'planta',
            width: 50,
        },
        {
            title: 'Usuario',
            dataIndex: 'usuario',
            width: 50,
        },
        {
            title: 'Galones',
            dataIndex: 'cantidad_galones',
            width: 50,
        },
        {
            title: 'Total',
            dataIndex: 'cantidad_galones',
            width: 100,
            render: (_, record) => {
                return (Number(record.cantidad_galones) * Number(record.precio_gasolina)).toLocaleString("en-US", {style:"currency", currency:"USD"});
            }
        },
        // {   
        //     title: 'Opción',
        //     key: 'id',
        //     width: 250,
        //     render: (_, record) => {
        //         return (
        //             <>
        //                 <Space size="middle">
        //                     <Link to={"../cliente/editar/" + record.id}><Button size='small'>Editar</Button></Link>
        //                 </Space>
        //             </>
        //         );
        //     },
        // }
        

    ];


    const showTotalMessage = (total, range) => {
        
        let defaultMessage = `Mostrando ${range[0]}-${range[1]} de ${total} registros`;
        let filteredMessage = `${defaultMessage} que contienen "${search}". Resultados filtrados:  ${dataSource.length} registro.`;

        return search ? filteredMessage : defaultMessage;
    }
    
    return (
        <>
            <Table
                size="small"
                columns = {columns}
                dataSource = {dataSource}
                rowKey = 'id'
                scroll={{
                    x: "1000",
                }}
                tableLayout="auto"
                pagination= {false}
            >
            </Table>

            {pagination ? 
                <Row justify="end" style={{marginTop: 20}}>
                    <Pagination 
                        total={totalRecords}
                        defaultCurrent={pagination.current}
                        defaultPageSize={pagination.pageSize}
                        showSizeChanger
                        showQuickJumper
                        showTotal = {(total, range) => showTotalMessage(total, range)}
                        onChange={(page, pageSize) => onChange(page, pageSize)}
                    />
                </Row> 
            : ''}
            
        </>
    );
}